import { render, staticRenderFns } from "./PeppolSettings.vue?vue&type=template&id=24b15c14&scoped=true&"
import script from "./PeppolSettings.vue?vue&type=script&lang=js&"
export * from "./PeppolSettings.vue?vue&type=script&lang=js&"
import style0 from "./PeppolSettings.vue?vue&type=style&index=0&id=24b15c14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b15c14",
  null
  
)

export default component.exports